import { useAuth } from "@/auth/AuthProvider";

export function useIsAdmin(): boolean {
  const { user } = useAuth();
  return user?.role === "admin";
}
